exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-inner-menu-container[data-v-1bc183c6]{max-width:calc(100vw - 620px)!important}.nav-tooltip[data-v-1bc183c6]{font-size:14px}", ""]);

// exports
